module.exports = __webpack_public_path__ + "static/img/60.3bb5192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/60.png
// module id = a4kO
// module chunks = 3